export const OFFER_PRIORITIES = ["Primary", "Secondary"];
export const ACTIVE_STATES = ["Active", "Inactive"];
export const CAMPAIGN_STATUSES = ["Draft", "Active", "Paused", "Completed", "Archived"];
export const OPERATING_MODES = ["Review Required", "Autopilot"];
export const REVIEW_MODES = ["Review Required", "Autopilot"];
export const CONTENT_FORMATS = [
  "Short-form video",
  "Faceless video",
  "AI-presenter video",
  "Static graphic",
  "Carousel",
  "Text post",
  "Story",
  "Email",
];
export const CONTENT_PLATFORMS = ["Instagram", "TikTok", "Facebook", "YouTube", "LinkedIn", "Email"];
export const CONTENT_STATUSES = [
  "Idea",
  "Draft",
  "Generating",
  "Needs Review",
  "Approved",
  "Rejected",
  "Scheduled",
  "Published",
  "Failed",
  "Archived",
];
export const CREATION_SOURCES = ["Manual", "AI Generated", "AI Variation"];

export const CONTENT_STATUS_STYLES = {
  Idea: "bg-gray-100 text-gray-600",
  Draft: "bg-slate-100 text-slate-600",
  Generating: "bg-indigo-100 text-indigo-700",
  "Needs Review": "bg-amber-100 text-amber-700",
  Approved: "bg-emerald-100 text-emerald-700",
  Rejected: "bg-red-100 text-red-700",
  Scheduled: "bg-blue-100 text-blue-700",
  Published: "bg-purple-100 text-purple-700",
  Failed: "bg-red-100 text-red-700",
  Archived: "bg-gray-100 text-gray-500",
};

export const CAMPAIGN_STATUS_STYLES = {
  Draft: "bg-slate-100 text-slate-600",
  Active: "bg-emerald-100 text-emerald-700",
  Paused: "bg-amber-100 text-amber-700",
  Completed: "bg-blue-100 text-blue-700",
  Archived: "bg-gray-100 text-gray-500",
};

export const slug = (s) => (s || "").replace(/[^a-z0-9]+/gi, "-").toLowerCase();

export const ASSET_TYPES = [
  "Primary logo", "Alternate logo", "Brand mark", "Founder photograph",
  "Clinic/classroom photograph", "Product or course image", "Background",
  "Font", "Brand color", "Disclaimer text", "Outro card", "Default CTA card",
];

export const MEDIA_STATUS_STYLES = {
  "Waiting for Media": "bg-gray-100 text-gray-600",
  "Media Queued": "bg-slate-100 text-slate-600",
  "Media Generating": "bg-indigo-100 text-indigo-700",
  "Media Review": "bg-amber-100 text-amber-700",
  "Ready to Schedule": "bg-emerald-100 text-emerald-700",
  "Media Failed": "bg-red-100 text-red-700",
  Archived: "bg-gray-100 text-gray-500",
};

export const mediaFileUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/marketing/media/file/${path}`;
export const assetFileUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/marketing/assets/file/${path}`;
export const fmtBytes = (n) => (n == null ? "—" : n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${(n / 1024).toFixed(0)} KB`);
